import ReactDOM from 'react-dom';
import React, { useEffect, useState } from 'react';

interface Props {
  id?: string;
  children: React.ReactNode;
}

/**
 *  Portal 컴포넌트 (팝업 혹은 특정 위치에 컴포넌트를 렌더링 시켜야 할 때 사용하는 Portal 컴포넌트)
 * @param {string} id portal이 붙을 element의 id (기본값 protal)
 *  */
function Portal({ id = 'portal', children }: Props): JSX.Element | null {
  /* 마운트 되기 전에 실행이 되면 안 되기 때문에 마운트 후에 노드가 추가 되도록 하는 로직 */
  const [mounted, setMounted] = useState<boolean>(false);
  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  const element = typeof window !== 'undefined' && document.getElementById(id);
  return mounted ? (element && children ? ReactDOM.createPortal(children, element) : null) : null;
}

export default Portal;
